import { ReactElement } from 'react'

import { Trans } from '@lingui/react/macro'

export function UnsupportedNetworksText(): ReactElement {
  return <Trans>Please, connect your wallet to one of our supported networks.</Trans>
}
